import { Space, Typography } from 'antd';
import { Avatar } from 'components/common';
import { useChatStatusLabel } from 'hooks';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto } from 'types';
import OmiChanelChatSourceIcon from './OmiChanelChatSourceIcon';

type OmniChatSessionsProcessingItemProps = {
  chatSession: ChatSessionDto;
  onSelect?: (value: ChatSessionDto) => void;
  active?: boolean;
};
const OmniChatSessionsProcessingItem: React.FC<OmniChatSessionsProcessingItemProps> = ({
  onSelect,
  chatSession,
  active
}) => {
  const { unreadCount } = chatSession;
  const chatStatus = useChatStatusLabel(chatSession.status);

  return (
    <div
      id={`chat-session-${chatSession.chatSessionId}`}
      key={chatSession.chatSessionId}
      className={twMerge(
        'group flex h-[68px] cursor-pointer items-center px-4 py-3 transition-all hover:bg-colorBgSuccess',
        active && 'item-active bg-colorBgSuccess text-white hover:bg-colorBgSuccess hover:opacity-90'
      )}
      onClick={() => onSelect?.(chatSession)}
    >
      <div className='relative'>
        <Avatar
          key={chatSession.chatSessionId}
          size={48}
          src={chatSession.chat?.customerAvatar}
          name={chatSession.chat?.customerName}
        />
        <div className='absolute -bottom-1 -right-1 flex items-center justify-center'>
          <OmiChanelChatSourceIcon source={chatSession.chat?.source} />
        </div>
      </div>
      <div className='relative ml-3 flex flex-1 flex-col gap-[6px]'>
        <Space size={0} direction='horizontal' className='flex items-center justify-between'>
          <Space size={8}>
            <Typography.Text ellipsis className='max-w-[220px] text-sm font-semibold group-hover:text-white'>
              {chatSession.chat?.customerName}
            </Typography.Text>
          </Space>
        </Space>

        <Space size={0} direction='horizontal' className='flex items-center justify-between'>
          <div className='flex max-w-[272px] gap-[2px]'>
            <Typography.Text type='secondary' className='text-sm group-hover:text-white'>
              {chatStatus}
            </Typography.Text>
          </div>
        </Space>
        {unreadCount && unreadCount > 0 ? (
          <div className='absolute right-4 top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-[#FF2D54]'></div>
        ) : null}
      </div>
    </div>
  );
};
export default OmniChatSessionsProcessingItem;
